const sections = document.querySelectorAll('main .shopify-section');

sections.forEach((section) => section.classList.add('home-reveal'));

if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
  sections.forEach((section) => section.classList.add('home-reveal--visible'));
} else {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('home-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  sections.forEach((section) => observer.observe(section));
}
